module.exports = __webpack_public_path__ + "static/img/Az_mzjg_icon.png";